import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { updateBankAccount } from '../requests'
import { BankAccount, UpdateBankAccountRequest } from '../schema'

function useUpdateBankAccount(
  options?: Omit<
    UseMutationOptions<BankAccount, Error, UpdateBankAccountRequest>,
    'mutationFn'
  >
) {
  return useMutation({
    mutationFn: updateBankAccount,
    ...options,
  })
}

export default useUpdateBankAccount
